/**
 * Source type constants for session data sources
 * These values match the backend session.source_type field
 */
export const SourceTypes = {
  LIVE_RECORDING: "live_recording",
  WAV_FILE: "wav_file",
  MP3_FILE: "mp3_file",
  VIDEO_FILE: "video_file",
  PDF: "pdf",
  TEXT_UPLOAD: "text_upload",
  IMPORTED: "imported",
} as const;

export type SourceType = typeof SourceTypes[keyof typeof SourceTypes];
